import { createContext, useContext } from 'react';

import { useSupplierDetails } from './hook';

type SupplierDetailsContext = ReturnType<typeof useSupplierDetails>;

export const SupplierDetailsContext =
    createContext<SupplierDetailsContext | null>(null);

export const SupplierDetailsProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const supplierDetails = useSupplierDetails();

    return (
        <SupplierDetailsContext.Provider value={supplierDetails}>
            {children}
        </SupplierDetailsContext.Provider>
    );
};

export const useSupplierDetailsContext = () => {
    const context = useContext(SupplierDetailsContext);
    if (!context) {
        throw new Error(
            'useSupplierDetailsContext must be used within a SupplierDetailsProvider',
        );
    }
    return context;
};
